/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = {}, n = (t) => String(t).trim().split(" "), l = (t, s) => {
  const r = n(s);
  return !!n(t.className).find((i) => r.indexOf(i) >= 0);
}, c = (t) => (s) => l(s, t), f = (t) => (e[t] || (e[t] = (s) => String(s.nodeName).toLowerCase() === t.toLowerCase()), e[t]), a = (t, s, r = !0) => {
  if (t) {
    if (r && s(t))
      return t;
    for (t = t.firstChild; t; ) {
      if (t.nodeType === 1) {
        const i = a(t, s);
        if (i)
          return i;
      }
      t = t.nextSibling;
    }
  }
};
export {
  a as findElement,
  l as hasClasses,
  c as matchesClasses,
  f as matchesNodeName
};
